export default "__VITE_ASSET__DMt7G1Bp__"